import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme, Menu as MuiMenu, MenuItem as MuiMenuItem, Avatar, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { ExpandLess, ExpandMore, MenuOutlined } from "@mui/icons-material";
import apiService from "../../service/apiService";
import pagesData from "../../pages.json";
import * as MuiIcons from "@mui/icons-material";
import logo from '../../assets/images/icardalogo.png';

const getMuiIcon = (iconName) => {
  const IconComponent = MuiIcons[iconName]; 
  return IconComponent ? <IconComponent /> : <HelpOutlineOutlinedIcon />;
};

const Sidebar = () => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [apiData, setApiData] = useState([]);
  const [sidebarItems, setSidebarItems] = useState([]);
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('loginData');
    navigate('/login'); 
    handleMenuClose();
  };
  const fetchSidebar = async (data) => {
        try {
          const response = await apiService.get(`/rbac/get-form-by-user-role/${data}`);
          
          setApiData(response.data); 
        } catch (error) {
          console.error("Error fetching Sidebar:", error);
        }
      }
      useEffect(() => {
        if (loginData?.userRoleId > 0) {
          fetchSidebar(loginData.userRoleId);
        }
      }, [loginData?.userRoleId]);
    
      useEffect(() => {
        const getFallbackDataFromPagesData = () => {
          return Object.entries(pagesData.pages || {}).map(([formId, page]) => {
            const innerPages = page.innerPages
              ? Object.entries(page.innerPages).map(([subFormId, subPage]) => ({
                  formId: parseInt(subFormId, 10),
                  formName: subPage.name,
                  url: subPage.url || "#",
                  icon: getMuiIcon(subPage.icon) || <HomeOutlinedIcon />, 
                  displayOrder: subPage.displayOrder || 0,
                }))
              : null;
      
            return {
              formId: parseInt(formId, 10),
              formName: page.name,
              url: page.url || "#",
              icon: getMuiIcon(page.icon),
              displayOrder: page.displayOrder || 0,
              innerPages,
            };
          });
        };
      
        if (apiData?.body && Array.isArray(apiData.body)) {
          const enhancedData = apiData.body
            .map((item) => {
              const parentInnerPages = pagesData.pages[String(item.formId)]?.innerPages || {};
              const innerPages = item.subForms
                ? item.subForms
                    .map((subItem) => ({
                      formId: subItem.formId,
                      formName: subItem.formName,
                      url: parentInnerPages[String(subItem.formId)]?.url || "#",
                      icon: getMuiIcon(parentInnerPages[String(subItem.formId)]?.icon),
                      displayOrder: subItem.displayOrder || 0,
                    }))
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                : null;
      
              return {
                formId: item.formId,
                formName: item.formName,
                url: pagesData.pages[String(item.formId)]?.url || "#",
                icon: getMuiIcon(pagesData.pages[String(item.formId)]?.icon),
                displayOrder: item.displayOrder || 0,
                innerPages,
              };
            })
            .sort((a, b) => a.displayOrder - b.displayOrder);
      
          setSidebarItems(enhancedData);
          console.log("perticular data are", enhancedData)
        } else {
          const fallbackData = getFallbackDataFromPagesData();
          setSidebarItems(fallbackData);
          console.log("withoutanydata", fallbackData);
        }
      }, [apiData, pagesData]);

  const toggleMenu = (title) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100vh',
        width: isCollapsed ? "80px" : "270px",
        transition: "width 0.3s"
      }}
    >
      <ProSidebar collapsed={isCollapsed} style={{ height: "100%", padding: "0px" }}>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          {/* Menu Items Container */}
          <Box sx={{ flexGrow: 1 }}>
            <Menu iconShape="square">
              <Box sx={{
                "& .pro-inner-item": { padding: "10px 0px 0px 10px !important" },
                "& .pro-icon-wrapper": { marginRight: isCollapsed ? "0px !important" : undefined },
              }}>
                <MenuItem
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  icon={<MenuOutlined />}
                >
                  {!isCollapsed && (
                    <div className="pl-5">
                    <img
                      src={logo}
                      alt="Logo"
                      className="logo"
                      style={{ width: '60px', height: 'auto' }}
                    />
                  </div>
                  )}
                </MenuItem>
               {!isCollapsed && loginData && (
  <div className="mt-4 mb-4 fw-bold text-center" style={{ fontSize: "20px" }}>
    {loginData.districtCoordinatorsId && loginData.blockCoordinatorsId
      ? "Block Coordinator"
      : loginData.districtCoordinatorsId
      ? "District Coordinator"
      : "Admin"}
  </div>
)}

              </Box>
              {sidebarItems.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    "& .pro-inner-item": { padding: "5px 0px 5px 10px !important" },
                    "& .pro-icon-wrapper": { marginRight: isCollapsed ? "0px !important" : undefined },
                    "&:hover": {
                      backgroundColor: "#505050 !important", 
                      color: "white", 
                    },
                  }}
                >
                  <MenuItem
                    icon={item.icon}
                    onClick={() => {
                      if (item.innerPages?.length > 0) {
                        toggleMenu(item.formName);
                      } else {
                        navigate(item.url);
                      }
                    }}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    {!isCollapsed && item.formName}
                    {item.innerPages?.length > 0 && (
                      <IconButton
                        size="medium"
                        sx={{ color: "white", mr: isCollapsed ? 0.5 : 0 }}
                      >
                        {expandedMenus[item.formName] ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    )}
                  </MenuItem>
                  {item.innerPages?.length > 0 && expandedMenus[item.formName] && (
                    <Box sx={{ marginLeft: isCollapsed ? "8px" : "30px" }}>
                      {item.innerPages.map((subItem, subIndex) => (
                        <MenuItem key={subIndex} icon={subItem.icon}>
                          <Link to={subItem.url} />
                          {!isCollapsed && subItem.formName}
                        </MenuItem>
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
            </Menu>
          </Box>
          {/* Fixed User Avatar at the Bottom */}
          <Box sx={{ padding: "5px", backgroundColor: "#222" }}>
            <IconButton onClick={handleMenuClick} sx={{ color: "white" }}>
              <Avatar sx={{ width: 32, height: 32 }} />
            </IconButton>
            <MuiMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <div style={{ padding: "10px", textAlign: "center" }}>
                <strong>{loginData?.userName || "No User"}</strong>
              </div>
              <Divider />
              <div style={{ padding: "10px", textAlign: "center" }}>
                <button onClick={handleLogout} className="btn btn-sm btn-danger">
                  Logout
                </button>
              </div>
            </MuiMenu>

          </Box>
        </Box>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
